import { call, put, takeLatest, all, select, delay, takeEvery } from "redux-saga/effects";
import {
  FETCH_PROFILE_DETAILS,
  FETCH_PROFILE_DETAILS_SUCCESS,
  FETCH_PROFILE_DETAILS_FAILURE,
  CHANGE_LANGUAGE,
  FETCH_ACCESS_CARD_SUCCESS,
  FETCH_ACCESS_CARD_FAILURE,
  FETCH_ACCESS_CARD,
  FETCH_CART_SUCCESS,
  FETCH_CART_FAILURE,
  POST_CART_SUCCESS,
  FETCH_CART,
  POST_CART,
  FETCH_HOME_DATA_SUCCESS,
  FETCH_HOME_DATA_FAILURE,
  FETCH_HOME_DATA,
  REMOVE_ACCESS_CARD_SUCCESS,
  REMOVE_ACCESS_CARD_FAILURE,
  REMOVE_ACCESS_CARD_REQUEST,
  REMOVE_ACCESS_CARDS_BULK_REQUEST,
  REMOVE_ACCESS_CARDS_BULK_SUCCESS,
  REMOVE_ACCESS_CARDS_BULK_FAILURE,
  FETCH_ORG_ALBUMS,
  FETCH_ORG_ALBUMS_SUCCESS,
  FETCH_ORG_ALBUMS_FAILURE,
  POST_CART_FAILURE,
} from "./actions";
import {
  POST_EVENT_ORDER_META_UPDATE_REQ,
  POST_EVENT_ORDER_META_UPDATE_FAILURE,
  POST_EVENT_ORDER_META_UPDATE_SUCCESS,
  GET_REQUIRED_ADDRESS_TYPE_FOR_CUSTOMER_REQ,
  GET_REQUIRED_ADDRESS_TYPE_FOR_CUSTOMER_SUCCESS,
  GET_REQUIRED_ADDRESS_TYPE_FOR_CUSTOMER_FAILURE,
  GET_PRODUCTS_DATA_FOR_EVENT_SUCCESS,
  GET_PRODUCTS_DATA_FOR_EVENT_FAILURE,
  GET_PRODUCTS_DATA_FOR_EVENT_REQ,
  GET_CUSTOMER_OFFERS_REQ,
  GET_CUSTOMER_OFFERS_SUCCESS,
  GET_CUSTOMER_OFFERS_FAILURE,
  GET_ADDRESS_DATA_REQ,
  GET_ADDRESS_DATA_SUCCESS,
  GET_ADDRESS_DATA_FAILURE,
  POST_NEW_ADDRESS_REQ,
  POST_NEW_ADDRESS_SUCCESS,
  POST_NEW_ADDRESS_FAILURE,
  PO_INIT_REQ,
  PO_INIT_SUCCESS,
  PO_INIT_FAILURE,
  FETCH_PAYBOX_DATA,
  FETCH_PAYBOX_DATA_SUCCESS,
  FETCH_PAYBOX_DATA_FAILURE,
  APPLY_OFFER_TO_CART_REQ,
  APPLY_OFFER_TO_CART_SUCCESS,
  APPLY_OFFER_TO_CART_FAILURE,
  GET_PAYMENT_RESULT_SUCCESS,
  GET_PAYMENT_RESULT_FAILURE,
  GET_PAYMENT_RESULT,
  GET_CUSTOMER_PURCHASE_ORDERS_REQ,
  GET_CUSTOMER_PURCHASE_ORDERS_SUCCESS,
  DOWNLOAD_HD_IN_ORDER_SUCCESS,
  DOWNLOAD_HD_IN_ORDER,
  GET_OTP_FOR_ACCESS_CARD,
  GET_OTP_FOR_ACCESS_CARD_SUCCESS,
  GET_OTP_FOR_ACCESS_CARD_FAILURE,
  VERIFY_ACCESS_CARD_OTP,
  VERIFY_ACCESS_CARD_OTP_SUCCESS,
  VERIFY_ACCESS_CARD_OTP_FAILURE,
  POST_PO_ADDRESS_REQ,
  POST_PO_ADDRESS_SUCCESS,
  POST_PO_ADDRESS_FAILURE,
  GET_PO_ADDRESS_REQ,
  GET_PO_ADDRESS_SUCCESS,
  GET_PO_ADDRESS_FAILURE,
} from "./constants";

import {
  getAddressDataAPI,
  getProductData,
  getRequiredAddresTypeAPI,
  // generatePOForCustomerAPI,
  getCustomerOffersAPI,
  applyOfferAPI,
  getCustomerPurchaseOrdersAPI,
  downloadHDInOrderAPI
} from "services/getAPIs";
import {
  postNewAddressAPI, generateNewPOForCustomerAPI, accessCardGetOTPAPI,
  loginAccessCardOTPAPI, postPONewAddressAPI
} from "services/postAPIs";
import { getProfileDetails } from "services/profileDetails";
// import { getOffers } from "services/offers";
import { getAccessCard, removeAccessCard, getOrgAccessCards, removeAccessCardsBulk } from "services/accessCard";

import { postKidsName } from "services/postAPIs";
import { getCartAPI, postCartAPI } from "services/cart";
import { getHomeData } from "services/homePage";
import { getPayboxDataAPI, getPaymentResultAPI } from "services/payments";
import { setJWTTokens } from "utils/tokens";

function* watchLanguageChange() {
  // eslint-disable-next-line require-yield
  yield takeLatest(CHANGE_LANGUAGE, function* (action) {
    const language = action.payload;
    sessionStorage.setItem("pFlanguage", language);
  });
};

function* postEventOrderMetaUpdateSaga(action) {
  const updateType = action?.payload || "kidsName";

  const kidsName = yield select((store) => store.kidsName);
  const orgId = yield select((store) => store.accessCardOrgId);
  const customerPO = yield select((store) => store.customerPO);

  const billingAddressId = yield select((store) => store.checkOutStepsData?.billingAddressId || null);
  const shippingAddressId = yield select((store) => store.shippingAddress?.id || null);

  const payload = updateType === "kidsName" ? {
    kidsName,
    orgId,
    customerPO
  } : {
    billingAddressId,
    shippingAddressId,
    orgId,
    customerPO,
  };

  try {
    const response = yield call(postKidsName, payload);
    yield put({ type: POST_EVENT_ORDER_META_UPDATE_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: POST_EVENT_ORDER_META_UPDATE_FAILURE, payload: error });
  }
}

function* fetchAddressDataSaga() {
  try {
    const data = yield call(getAddressDataAPI);
    yield put({ type: GET_ADDRESS_DATA_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: GET_ADDRESS_DATA_FAILURE, payload: error });
  }
}

function* postNewAddressSaga(action) {
  try {
    const response = yield call(postNewAddressAPI, action.payload);
    if (response.status === 201) {
      yield put({ type: POST_NEW_ADDRESS_SUCCESS, payload: response });
      // call fetchAddressDAtaSaga here again to update address data
      yield put({ type: GET_ADDRESS_DATA_REQ });
    } else {
      const errorPayload = {
        status: response.status,
        message: response.statusText || "Unknown error occurred", // Include any error message returned by the server
        data: response.data || null // Include any data returned by the server
      };

      yield put({ type: POST_NEW_ADDRESS_FAILURE, payload: errorPayload });
    }
  } catch (error) {
    yield put({ type: POST_NEW_ADDRESS_FAILURE, payload: error });
  }
}

function* fetchProfileDetailsSaga() {
  yield delay(500);
  try {
    const data = yield call(getProfileDetails);
    yield put({ type: FETCH_PROFILE_DETAILS_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: FETCH_PROFILE_DETAILS_FAILURE, payload: error });
  }
}

function* fetchCustomerOffersSaga(action) {
  yield delay(500);
  try {
    const responseData = yield call(getCustomerOffersAPI);
    yield put({ type: GET_CUSTOMER_OFFERS_SUCCESS, payload: responseData });
  } catch (error) {
    yield put({ type: GET_CUSTOMER_OFFERS_FAILURE, payload: error });
  }
};

function* fetchAccessCardSaga(action) {
  yield delay(500);

  try {
    const { accessId, accessCode, orgId, clearOthers } = action.payload;
    const language = yield select((store) => store.language);
    yield delay(500);

    const response = yield call(getAccessCard, accessId, accessCode, orgId, language, clearOthers);
    if (response.status === 200) {

      yield put({ type: FETCH_ACCESS_CARD_SUCCESS, payload: response.data });
    } else {
      yield put({
        type: FETCH_ACCESS_CARD_FAILURE,
        payload: response.error.error || "Failed to fetch access card",
      });
    }
  } catch (error) {
    yield put({ type: FETCH_ACCESS_CARD_FAILURE, payload: error.message });
  }
}

function* fetchOrgAlbumsSaga() {
  try {
    const response = yield call(getOrgAccessCards);
    yield put({ type: FETCH_ORG_ALBUMS_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: FETCH_ORG_ALBUMS_FAILURE, payload: error });
  }
}

function* fetchCartSaga(action) {
  yield delay(500);
  try {
    const language = yield select((store) => store.language);
    action.payload = {
      ...action.payload, language
    };
    const data = yield call(getCartAPI, action.payload);
    yield put({ type: FETCH_CART_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: FETCH_CART_FAILURE, payload: error.message });
  }
}


function* postCartSaga(action) {
  try {
    const language = yield select((store) => store.language);
    action.payload = {
      ...action.payload, language
    };
    const response = yield call(postCartAPI, action.payload); // Your API call
    yield put({ type: POST_CART_SUCCESS, payload: response });

    // ✅ call callback if provided
    if (typeof action.payload.callback === "function") {
      action.payload.callback(true, response);
    }

  } catch (error) {
    yield put({ type: POST_CART_FAILURE, error });

    if (typeof action.payload.callback === "function") {
      action.payload.callback(false, error);
    }
  }
};

function* fetchHomeDataSaga() {
  yield delay(500);
  try {
    const data = yield call(getHomeData);
    yield put({ type: FETCH_HOME_DATA_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: FETCH_HOME_DATA_FAILURE, payload: error.message });
  }
}

function* getRequiredAddressTypeSaga() {
  try {
    const data = yield call(getRequiredAddresTypeAPI);
    yield put({
      type: GET_REQUIRED_ADDRESS_TYPE_FOR_CUSTOMER_SUCCESS,
      payload: data
    });
  } catch (error) {
    yield put({
      type: GET_REQUIRED_ADDRESS_TYPE_FOR_CUSTOMER_FAILURE,
      payload: error
    });
  }
}

function* getProductsSaga(eventData) {
  yield delay(500);
  try {
    const data = yield call(getProductData, eventData.payload);
    yield put({ type: GET_PRODUCTS_DATA_FOR_EVENT_SUCCESS, data });
  } catch (error) {
    yield put({ type: GET_PRODUCTS_DATA_FOR_EVENT_FAILURE, error });
  }
}

function* removeAccessCardSaga(action) {
  try {
    const { accessId, accessCode } = action.payload;
    const response = yield call(removeAccessCard, accessId, accessCode);
    yield put({
      type: REMOVE_ACCESS_CARD_SUCCESS,
      payload: response.data
    });
    // yield put({ type: FETCH_HOME_DATA });
  } catch (error) {
    yield put({ type: REMOVE_ACCESS_CARD_FAILURE, payload: error.message });
  }
}

function* removeAccessCardsBulkSaga(action) {
  try {
    const { accessUids } = action.payload;
    const response = yield call(removeAccessCardsBulk, accessUids);
    yield put({
      type: REMOVE_ACCESS_CARDS_BULK_SUCCESS,
      payload: {
        ...response.data,
        requested_access_uids: accessUids
      }
    });
  } catch (error) {
    yield put({
      type: REMOVE_ACCESS_CARDS_BULK_FAILURE,
      payload: {
        error: error.message,
        requested_access_uids: action.payload?.accessUids || []
      }
    });
  }
}

function* initPOForParentSaga() {
  yield delay(500);
  try {
    const data = yield call(generateNewPOForCustomerAPI);
    yield put({ type: PO_INIT_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: PO_INIT_FAILURE, payload: error });
  }
};

function* applyOfferSaga(action) {
  try {
    const data = yield call(applyOfferAPI, action.payload);
    yield put({ type: APPLY_OFFER_TO_CART_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: APPLY_OFFER_TO_CART_FAILURE, payload: error });
  }
}

function* fetchPayboxDataSaga(action) {
  try {
    const data = yield call(getPayboxDataAPI, action.payload);
    yield put({ type: FETCH_PAYBOX_DATA_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: FETCH_PAYBOX_DATA_FAILURE, payload: error });
  }
}

function* getPayboxPaymentResultSaga(action) {
  try {
    const data = yield call(getPaymentResultAPI, action);
    yield put({ type: GET_PAYMENT_RESULT_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: GET_PAYMENT_RESULT_FAILURE, payload: error });
  }
}

function* getCustomerPurchaseOrdersSaga() {
  try {
    yield delay(500);
    const data = yield call(getCustomerPurchaseOrdersAPI);
    yield put({ type: GET_CUSTOMER_PURCHASE_ORDERS_SUCCESS, payload: data });
  } catch (error) {
    console.error("Error fetching customer purchase orders:", error);
    // yield put(getCustomerPurchaseOrdersFailure(error));
  }
};

function* downloadHDInOrderSaga(action) {
  try {
    const data = yield call(downloadHDInOrderAPI, action.payload);
    yield put({ type: DOWNLOAD_HD_IN_ORDER_SUCCESS, payload: data });
  } catch (error) {
    console.log("error downloading hd saga", error);
  }
};

function* getAccessCardOTPLoginSaga(action) {
  try {
    // const { email } = action.payload;
    const payload = action.payload;

    const response = yield call(accessCardGetOTPAPI, payload);

    yield put({ type: GET_OTP_FOR_ACCESS_CARD_SUCCESS, payload: response.data });
  } catch (error) {
    console.log("Access card OTP API error", error?.response);
    yield put({ type: GET_OTP_FOR_ACCESS_CARD_FAILURE, payload: error.message });
  }
};

function* verifyAccessCardOTPSaga(action) {

  try {

    const { email, otp, albumID, accessUID } = action.payload;
    const response = yield call(loginAccessCardOTPAPI, { email, otp, albumID, accessUID });
    if (response.status === 200) {
      setJWTTokens(response.data);
      yield put({ type: VERIFY_ACCESS_CARD_OTP_SUCCESS, payload: response.data });
    } else {
      console.log("Verify OTP error response non 200", response);
      yield put({ type: VERIFY_ACCESS_CARD_OTP_FAILURE, payload: response.error });
    }
  } catch (error) {
    console.log("Verify OTP exception", error?.response?.data?.custom_response?.message);
    yield put({ type: VERIFY_ACCESS_CARD_OTP_FAILURE, payload: error?.response?.data?.custom_response?.message });
  }
};

function* postPOAddressSaga(action) {

  let billingAddressId = null;
  let shippingAddressId = null;

  billingAddressId = localStorage.getItem("billingAddressId") || null;
  shippingAddressId = localStorage.getItem("shippingAddressId") || null;

  const sameAsBilling = localStorage.getItem("sameAsBilling") === "true";

  shippingAddressId = sameAsBilling ? billingAddressId : shippingAddressId;

  const customerPO = action?.payload?.poid
    ? action.payload?.poid : null;
  const payload = {
    billingAddressId,
    shippingAddressId,
    customerPO,
    sameAsBilling
  };

  try {
    const response = yield call(postPONewAddressAPI, payload);
    yield put({ type: POST_PO_ADDRESS_SUCCESS, payload: response });
    // Clear localStorage items after successful submission
    localStorage.removeItem("billingAddressId");
    localStorage.removeItem("shippingAddressId");
    localStorage.removeItem("sameAsBilling");
    return response;
  } catch (error) {
    yield put({ type: POST_PO_ADDRESS_FAILURE, payload: error });
  }
};

function* getPOAddressSaga(action) {
  try {
    const data = yield call(getAddressDataAPI, action.payload);
    yield put({ type: GET_PO_ADDRESS_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: GET_PO_ADDRESS_FAILURE, payload: error });
  }
};


export default function* rootSaga() {
  yield all([
    takeLatest(GET_ADDRESS_DATA_REQ, fetchAddressDataSaga),
    takeLatest(POST_NEW_ADDRESS_REQ, postNewAddressSaga),
    takeLatest(FETCH_PROFILE_DETAILS, fetchProfileDetailsSaga),
    takeLatest(GET_CUSTOMER_OFFERS_REQ, fetchCustomerOffersSaga),
    takeLatest(FETCH_ACCESS_CARD, fetchAccessCardSaga),
    takeLatest(FETCH_ORG_ALBUMS, fetchOrgAlbumsSaga),
    takeLatest(POST_EVENT_ORDER_META_UPDATE_REQ, postEventOrderMetaUpdateSaga),
    takeLatest(FETCH_CART, fetchCartSaga),
    takeLatest(POST_CART, postCartSaga),
    takeLatest(FETCH_PAYBOX_DATA, fetchPayboxDataSaga),
    takeLatest(FETCH_HOME_DATA, fetchHomeDataSaga),
    takeLatest(
      GET_REQUIRED_ADDRESS_TYPE_FOR_CUSTOMER_REQ,
      getRequiredAddressTypeSaga
    ),
    takeLatest(GET_PRODUCTS_DATA_FOR_EVENT_REQ, getProductsSaga),
    takeLatest(REMOVE_ACCESS_CARD_REQUEST, removeAccessCardSaga),
    takeLatest(REMOVE_ACCESS_CARDS_BULK_REQUEST, removeAccessCardsBulkSaga),
    takeLatest(APPLY_OFFER_TO_CART_REQ, applyOfferSaga),
    takeLatest(PO_INIT_REQ, initPOForParentSaga),
    takeLatest(GET_PAYMENT_RESULT, getPayboxPaymentResultSaga),
    takeLatest(GET_CUSTOMER_PURCHASE_ORDERS_REQ, getCustomerPurchaseOrdersSaga),
    takeLatest(GET_OTP_FOR_ACCESS_CARD, getAccessCardOTPLoginSaga),
    takeLatest(VERIFY_ACCESS_CARD_OTP, verifyAccessCardOTPSaga),
    takeEvery(DOWNLOAD_HD_IN_ORDER, downloadHDInOrderSaga),
    takeLatest(POST_PO_ADDRESS_REQ, postPOAddressSaga),
    takeLatest(GET_PO_ADDRESS_REQ, getPOAddressSaga),
    watchLanguageChange()
  ]);
}
